import { gql } from "@apollo/client";

export const getUniformItemsQuery = gql`
query($includeArchived: Boolean){
  getUniformItems(includeArchived: $includeArchived){
    response
    message
  }
}
`;

export const getUniformRequestsQuery = gql`
query($filter: UniformRequestFilter){
  getUniformRequests(filter: $filter){
    response
    message
  }
}
`;

export const getUniformIssuesQuery = gql`
query($filter: UniformIssueFilter){
  getUniformIssues(filter: $filter){
    response
    message
  }
}
`;

export const getUniformSummaryQuery = gql`
query($from: String, $to: String){
  getUniformSummary(from: $from, to: $to){
    response
    message
  }
}
`;

export const getMyUniformQuery = gql`
query{
  getMyUniform{
    response
    message
  }
}
`;

// the standards the module is built to, the categories and their ratings, the standard size
// lists and the catalogue (the same for every company)
export const getUniformStandardsQuery = gql`
query{
  getUniformStandards{
    response
    message
  }
}
`;

export const getUniformSizeListsQuery = gql`
query($includeArchived: Boolean){
  getUniformSizeLists(includeArchived: $includeArchived){
    response
    message
  }
}
`;

export const getUniformComplianceQuery = gql`
query($employeeId: String){
  getUniformCompliance(employeeId: $employeeId){
    response
    message
  }
}
`;

export const getUniformReceiptsQuery = gql`
query($employeeId: String, $status: String, $page: Int, $pageSize: Int){
  getUniformReceipts(employeeId: $employeeId, status: $status, page: $page, pageSize: $pageSize){
    response
    message
  }
}
`;

export const getUniformReceiptQuery = gql`
query($id: String!){
  getUniformReceipt(id: $id){
    response
    message
  }
}
`;
